import MarketingContentPage from "@/components/marketing/MarketingContentPage"

export default function Integrations() {
  return <MarketingContentPage pageKey="integrations" seoKey="integrations" />
}
